import React from "react";
import { useTranslation } from "react-i18next";
import {
  Box,
  TextField,
  Autocomplete,
  autocompleteClasses,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import useStyles from "./styles";
import { Colors, CommonFonts } from "@/theme";

const RangePicker = (props) => {
  const { ranges, range, onChange } = props;
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <Box>
      <span className={classes.selectText}>
        {t("price_monitor_screen.set_range")}
      </span>
      <Autocomplete
        className={classes.selectContainer}
        options={ranges}
        getOptionLabel={(option) => `${option} miles`}
        renderInput={(params) => <TextField {...params} />}
        popupIcon={<ExpandMoreIcon sx={{ color: Colors.GRAY_DARK }} />}
        value={range}
        onChange={(event, newValue) => {
          onChange(newValue);
        }}
        disableClearable
        blurOnSelect
        renderOption={(props, option, state, ownerState) => (
          <Box
            sx={{
              [`&.${autocompleteClasses.option}`]: {
                padding: "8px",
                ...CommonFonts.darkBoldFont22,
              },
            }}
            component="li"
            {...props}
          >
            {ownerState.getOptionLabel(option)}
          </Box>
        )}
      />
    </Box>
  );
};

export default RangePicker;
